import { useCallback, useState } from 'react'

import { type Shipment } from '../../domain/Shipment'
import { AssignTruckNumberDialog } from './AssignTruckNumberDialog'
import { EmptyTruckNumberCardContent } from './EmptyTruckNumberCardContent'
import { TruckNumberCardContent } from './TruckNumberCardContent'
import { UnassignTruckNumberDialog } from './UnassignTruckNumberDialog'

type TruckNumberCardProps = {
  readonly shipment: Shipment
  readonly onTruckChanged: (uuid: string) => void
}

const enum TruckDialogs {
  assignTruck = 'assignTruck',
  unassignTruck = 'unassignTruck',
}

export function TruckNumberCard({ shipment, onTruckChanged }: TruckNumberCardProps) {
  const [openDialog, setOpenDialog] = useState<TruckDialogs | null>(null)

  const handleTruckChanged = useCallback(() => {
    onTruckChanged(shipment.uuid)
  }, [onTruckChanged, shipment.uuid])

  return (
    <>
      {shipment.tractorNumber ? (
        <TruckNumberCardContent
          tractorNumber={shipment.tractorNumber}
          onClickEditTruck={() => setOpenDialog(TruckDialogs.assignTruck)}
          onClickUnassignTruck={() => setOpenDialog(TruckDialogs.unassignTruck)}
        />
      ) : (
        <EmptyTruckNumberCardContent onClick={() => setOpenDialog(TruckDialogs.assignTruck)} />
      )}
      {openDialog === TruckDialogs.assignTruck && (
        <AssignTruckNumberDialog
          open
          shipmentUUID={shipment.uuid}
          carrierUUID={shipment.carrier.uuid}
          tractorNumber={shipment.tractorNumber}
          onClose={() => setOpenDialog(null)}
          onTruckAssigned={handleTruckChanged}
        />
      )}
      {openDialog === TruckDialogs.unassignTruck && (
        <UnassignTruckNumberDialog
          open
          shipmentUUID={shipment.uuid}
          onClose={() => setOpenDialog(null)}
          onTruckUnassigned={handleTruckChanged}
        />
      )}
    </>
  )
}
